"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _paymentMonitorStatus = require("./paymentMonitorStatus");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PaymentMonitor',
  props: {
    monitor: {
      type: Object,
      default: null
    },
    platformOrderNo: {
      type: String,
      default: ''
    },
    refreshFailed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    evidence: function evidence() {
      return this.refreshFailed ? null : (0, _paymentMonitorStatus.matchingEvidence)(this.monitor, this.platformOrderNo);
    },
    wechat: function wechat() {
      return this.evidence && this.evidence.wechat || {};
    },
    jeequan: function jeequan() {
      return this.evidence && this.evidence.jeequan || {};
    },
    units: function units() {
      return Array.isArray(this.jeequan.units) ? this.jeequan.units : [];
    }
  },
  methods: {
    wechatOrderText: _paymentMonitorStatus.wechatOrderText,
    receiptText: _paymentMonitorStatus.receiptText,
    confirmMethodText: _paymentMonitorStatus.confirmMethodText,
    settlementText: _paymentMonitorStatus.settlementText,
    unitDivisionText: _paymentMonitorStatus.unitDivisionText,
    planText: _paymentMonitorStatus.planText,
    mallReceiptText: function mallReceiptText(unit) {
      return {
        UNRECEIVED: '未收货',
        RECEIVED: '已收货',
        CLOSED_REFUNDED: '已退款关闭'
      }[unit.mallReceiptState] || '未知';
    }
  }
};